export default function PageHeader({ title, subtitle, actions, testId }) {
    return (
        <div className="px-4 md:px-8 pt-6 md:pt-8 pb-5 md:pb-6 border-b border-[#E2E8F0] flex flex-col md:flex-row md:items-start md:justify-between gap-4" data-testid={testId}>
            <div className="min-w-0">
                <div className="overline mb-2">{subtitle}</div>
                <h1 className="font-display text-2xl sm:text-3xl md:text-4xl font-bold tracking-tight text-slate-900 break-words">{title}</h1>
            </div>
            <div className="flex items-center gap-2 flex-wrap">{actions}</div>
        </div>
    );
}
